<template>
    <TemplateModalEx v-model:show="computedShow" class="appMgrApplicationDetailModal">
        <template #title>詳細情報</template>

        <template #body>
            <div class="main-setting-table">
                <div class="main-category-text">
                    <span class="main-category-font">アプリケーション情報</span>
                </div>
            </div>
            <div class="scv-app-detail-area flex-row">
                <div>
                    <template v-if="0 != basicInfo.iconUrl.length">
                        <img :src="basicInfo.iconUrl" class="scv-app-detail-area-icon" style="margin-right: 16px;" />
                    </template>
                    <template v-else>
                        <div class="scv-app-detail-area-icon" style="margin-right: 16px;"></div>
                    </template>
                </div>
                <div class="d-flex flex-column flex-grow-1" style="margin-top: 16px; row-gap: 16px;">
                    <div class="scv-app-item-box">
                        <div class="scv-app-detail-title-box" style="min-width: 10em;">
                            アプリケーション名：
                        </div>
                        <div class="scv-app-detail-input-box">
                            <span class="scv-app-detail-input">{{ basicInfo.appName }} </span>
                        </div>
                    </div>
                    <div class="scv-app-item-box">
                        <div class="scv-app-detail-title-box" style="min-width: 10em;">
                            提供元：
                        </div>
                        <div class="scv-app-detail-input-box">
                            <span class="scv-app-detail-input">{{ basicInfo.author }} </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="scv-app-detail-area flex-column" style="row-gap: 16px; margin-top: 0px;">
                <div class="scv-app-item-box">
                    <div class="scv-app-detail-title-box">
                        パッケージ名：
                    </div>
                    <div class="scv-app-detail-input-box">
                        <span class="scv-app-detail-input">{{ basicInfo.packageName }} </span>
                    </div>
                </div>
                <div class="scv-app-item-box">
                    <div class="scv-app-detail-title-box">
                        カテゴリ：
                    </div>
                    <div class="scv-app-detail-input-box">
                        <span class="scv-app-detail-input">{{ basicInfo.category }} </span>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="modal-footer modal-footer-scv" style="border-top: none; padding: 0;">
                <div class="d-flex justify-content-center w-100">
                    <div zero-font>
                        <button type="button" class="btn-scv-white" @click="onClose">閉じる</button>
                    </div>
                </div>
            </div>
        </template>
    </TemplateModalEx>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import { cloneDeep } from 'lodash';
import { TemplateModalEx } from "lib-vue-v2/components";
import { AndroidAppMgrApplicationBasicJsonExtend } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrApplicationSetting';

interface Props {
    show?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    show: false
});

interface Emits {
    (event: "update:show", newValue: boolean): void;
}
const emit = defineEmits<Emits>();

// 表示非表示の切り替え
const refShow = ref(false);
const computedShow = computed({
    get: () => refShow.value,
    set: (newValue: boolean) => emit("update:show", newValue)
});

// メンバ変数
const basicInfo = ref(new AndroidAppMgrApplicationBasicJsonExtend());

// --- Watch ---
watch(() => props.show, (newVal) => {
    refShow.value = newVal;
    if (!newVal) {
        basicInfo.value = new AndroidAppMgrApplicationBasicJsonExtend();
    }
}, { immediate: true });

/**
 * @brief  データを設定します
 */
const SetData = (info: AndroidAppMgrApplicationBasicJsonExtend): void => {
    basicInfo.value = cloneDeep(info);
}

/**
 * @brief  閉じる
 */
const onClose = (): void => {
    emit("update:show", false);
}

// 呼び出し元から SetData を呼び出せるように expose する
defineExpose({
    SetData
});
</script>

<style lang="scss" scoped>
/* モーダルの幅などの調整が必要な場合はここで上書きします */
.appMgrApplicationDetailModal {
    :deep(.modal-content) {
        min-width: 700px;
        max-width: 700px;
        max-height: max-content;
    }
}

/* 横書きの情報box */
.scv-app-item-box {
    display: flex;
    flex-direction: row;
}

/* タイトル */
.scv-app-detail-title-box {
    height: 32px;
    /* タイトルを中央寄せするために32pxをセット */
    display: flex;
    align-items: center;
    min-width: 11em;
    justify-content: end;
    /* 右寄せ */
}

/* テキストエリア */
.scv-app-detail-input-box {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    min-height: 32px;
    margin-left: 4px;
    border-bottom: 1px solid #E1E6F5;
    width: 0px;
    /* 改行するために指定が必要 */
}

/* テキストエリア（最後の行は下線なし） */
.scv-app-detail-input-box.last-row-box {
    border-bottom: none !important;
}

/* テキスト */
.scv-app-detail-input {
    padding: 0px 8px;
    word-wrap: break-word;
    /* はみ出る分は改行 */
}

/* カテゴリ内のエリア */
.scv-app-detail-area {
    display: flex;
    flex-grow: 1;
    margin: 24px 0px 24px 16px;
}

/* アイコン */
.scv-app-detail-area-icon {
    height: 120px;
    width: 120px;
    border-radius: 26px;
    border: 0.5px solid #E6EBF0;
}
</style>
